module.exports = __webpack_public_path__ + "img/chart-bar.96e3f619.svg";